var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_615)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    transform: "translate(-653 -547)",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14_615)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4127 7.6024H9.15444V10.5857H13.3009C13.1221 11.5499 12.5797 12.3656 11.762 12.912C11.071 13.3741 10.189 13.6473 9.15243 13.6473C7.14551 13.6473 5.44797 12.2912 4.84127 10.4691C4.6886 10.0071 4.6002 9.51289 4.6002 9.00463C4.6002 8.49637 4.6886 8.00218 4.84127 7.54012C5.44998 5.72003 7.14752 4.36401 9.15444 4.36401C10.2855 4.36401 11.3 4.75374 12.0995 5.51713L14.3094 3.3053C12.9734 2.05976 11.2317 1.29637 9.15444 1.29637C6.14306 1.29637 3.53748 3.02405 2.26985 5.54325C1.74752 6.58387 1.4502 7.7611 1.4502 9.00664C1.4502 10.2522 1.74752 11.4274 2.26985 12.468C3.53748 14.9872 6.14306 16.7149 9.15444 16.7149C11.2357 16.7149 12.9794 16.0238 14.2531 14.8466C15.7096 13.5046 16.5513 11.5278 16.5513 9.17941C16.5513 8.63298 16.5031 8.10865 16.4127 7.6024Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "white",
    transform: "translate(-653 -547)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1441,
    height: 645,
    fill: "white",
    transform: "translate(-653 -437)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.613b3b40a0f25a79f8f23934848ecd4e.svg";
export { ForwardRef as ReactComponent };